module.exports = __webpack_public_path__ + "assets/dd584e48f5a561eafb698b0c8f1b1684.png";